import { gql } from "@apollo/client"

export const FIND_USERS_GLOBAL = gql`
  query findGlobal($data: FindUsersGlobalInput!) {
    usersManagement {
      findGlobal(data: $data) {
        hasMoreResults
        users {
          deleted
          districtId
          districtName
          fullname
          id
          roles
          schoolId
          schoolName
        }
      }
    }
  }
`
